export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8106.5918818c.jpg";